import React from 'react';
import PropTypes from 'prop-types';

const Neighborhood = ({ color = '#000', width = 7, height = 14 }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="vuesax/linear/buildings-2">
        <g id="buildings-2">
        <path id="Vector" d="M5.23001 15.4H2.93502C1.64802 15.4 1 14.752 1 13.465V2.93502C1 1.64802 1.64802 1 2.93502 1H6.80501C8.09201 1 8.73998 1.64802 8.73998 2.93502V4.6" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_2" d="M14.8329 16.8216C14.8329 18.2706 14.113 18.9996 12.664 18.9996H7.40794C5.95894 18.9996 5.22996 18.2706 5.22996 16.8216V6.77759C5.22996 5.32859 5.95894 4.59961 7.40794 4.59961H12.664C14.113 4.59961 14.8329 5.32859 14.8329 6.77759V16.8216Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_3" d="M11.2599 4.6V2.93502C11.2599 1.64802 11.9079 1 13.1949 1H17.0649C18.3519 1 18.9999 1.64802 18.9999 2.93502V13.465C18.9999 14.752 18.3519 15.4 17.0649 15.4H14.8329" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_4" d="M8.2 9.09961H11.8" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_5" d="M8.2 11.8008H11.8" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_6" d="M10 19.0008V16.3008" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        </g>
    </svg>
);

Neighborhood.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default Neighborhood; 